<template>
  <div>
    <div
      ref="public-searchForm"
      class="public-searchForm work-search"
    >
      <el-form
        ref="searchForm"
        :model="searchForm"
        labelWidth="100px"
        @keyup.enter.native="search"
      >
        <el-form-item
          style="width: 66.66%;"
          prop="date"
          label="创建时间范围"
        >
          <el-date-picker
            v-model="searchForm.date"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          />
        </el-form-item>
        <el-form-item
          prop="processStaus"
          label="流程状态"
        >
          <el-select
            v-model="searchForm.processStaus"
            placeholder="请选择流程状态"
            clearable
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          prop="processName"
          label="流程模型"
        >
          <el-input
            v-model="searchForm.processName"
            size="small"
            readonly
            class="select-input"
            suffix-icon="el-icon-search"
            placeholder="请选择流程模型"
            clearable
            @click.native="handleShowSelectForm"
          />
        </el-form-item>
        <el-form-item
          prop="createByName"
          label="发起人"
        >
          <el-input
            v-model="searchForm.createByName"
            size="small"
            placeholder="请选择发起人"
            readonly
            class="select-input"
            suffix-icon="el-icon-search"
            clearable
            @click.native="handleShowSelectUser"
          />
        </el-form-item>
        <el-form-item labelWidth="0">
          <div class="search-handler">
            <el-button
              icon="el-icon-refresh"
              @click="reset"
            >
              重置
            </el-button>
            <el-button
              type="primary"
              icon="el-icon-search"
              :loading="loading.search"
              @click="search"
            >
              查询
            </el-button>
            <el-button
              v-if="menuBottonRole.includes('export')"
              type="primary"
              icon="el-icon-download"
              @click="exportTable"
            >
              导出
            </el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="public-table">
      <div class="public-table-top">
        <div class="table-title">
          流程效率列表
        </div>
      </div>
      <el-table
        v-if="showTable"
        ref="tableData"
        :height="tableHeight"
        :data="tableData"
        border
      >
        <el-table-column
          v-for="item in tableCol"
          :key="item.key"
          :prop="item.key"
          :label="item.label"
          :min-width="item.minWidth"
          :formatter="formatter"
        />
      </el-table>
    </div>
    <div
      ref="public-pagination"
      class="public-pagination"
    >
      <WPagination
        v-model="page"
        @change="query"
      />
    </div>
    <select-user-dialog
      v-if="showSelectUser"
      @selectUser="selectUser"
      @close="showSelectUser = false"
    />
    <ModelDialog
      v-if="showSelectForm"
      modelType="0"
      title="选择流程模型"
      @formId="getFormId"
      @close="showSelectForm = false"
    />
  </div>
</template>

<script>
import selectUserDialog from './selectUserDialog.vue'
import ModelDialog from './modelDialog.vue'
import tableHeight from '@workflow/mixins/tableHeight.js'
export default {
  components: {
    selectUserDialog,
    ModelDialog
  },
  mixins: [tableHeight],
  data() {
    return {
      modelType: 3,
      loading: {
        search: false
      },
      showSelectForm: false,
      showSelectUser: false,
      options: [
        {
          value: 'notEnd',
          label: '流程中'
        },
        {
          value: 'end',
          label: '已结束'
        }
      ],
      searchForm: {
        processStaus: '',
        processName: '',
        createByName: '',
        createBy: '',
        createTime: '',
        endTime: ''
      },
      selectParam: {},
      page: {},
      tableData: [],
      tableCol: [
        { label: '流程模型', key: 'processName', minWidth: 150 },
        { label: '流程标题', key: 'processTitle', minWidth: 150 },
        { label: '流程单号', key: 'busnessKey', minWidth: 150 },
        { label: '创建人', key: 'createByView', minWidth: 100 },
        { label: '创建时间', key: 'createTime', minWidth: 150 },
        { label: '结束时间', key: 'endTime', minWidth: 150 },
        { label: '流程状态', key: 'processStaus', minWidth: 80 },
        { label: '当前节点', key: 'taskDefName', minWidth: 120 },
        { label: '当前操作者', key: 'assigneeView', minWidth: 100 },
        { label: '流程耗时（分钟）', key: 'processConsumeTime', minWidth: 100 }
      ],
      btnList: [
        { label: '修改', type: 0 },
        { label: '删除', type: 1 },
        { label: '报表数据', type: 2 }
      ]
    }
  },
  computed: {
    menuBottonRole() {
      const map = this.$store.state.workflow.menuBottonRole['/achievements/efficiency'] || []
      return map.map(item => item.menuUrl)
    }
  },
  mounted() {
    this.search()
  },
  methods: {
    formatter(row, column) {
      if (column.property === 'processStaus') {
        return row[column.property] === 'end' ? '已结束' : '流程中'
      }
      return row[column.property]
    },
    getFormId(id, name, modelKey) {
      this.searchForm.processName = modelKey
    },
    // 表单引用 表单列表弹窗
    handleShowSelectForm() {
      this.showSelectForm = true
    },
    selectUser(row) {
      this.searchForm.createByName = row.name
      this.searchForm.createBy = row.jobId
    },
    handleShowSelectUser() {
      this.showSelectUser = true
    },
    handleClick($event, row, type) {},
    reset() {
      this.$refs.searchForm.resetFields()
      this.searchForm.processName = ''
      this.searchForm.createByName = ''
      this.searchForm.createBy = ''
      this.search()
    },
    search() {
      this.page.current = 1
      this.page.size = 10
      this.selectParam = { ...this.searchForm }
      if (this.searchForm.date) {
        this.selectParam.createTime = this.selectParam.date[0]
        this.selectParam.endTime = this.selectParam.date[1]
        delete this.selectParam.date
      }
      delete this.selectParam.createByName
      this.query()
    },
    query() {
      const { current, size } = this.page
      this.loading.search = true
      this.$api.achievements.getTable({
        pageParam: { current, size },
        selectParam: this.selectParam
      }).then((data) => {
        this.controlData = {}
        this.tableData = data.records
        this.page.total = data.total
        if (!data.records.length) return this.$message.warning('查无数据！')
      }).finally(() => {
        this.loading.search = false
      })
    },
    exportTable() {
      this.selectParam = { ...this.searchForm }
      if (this.searchForm.date) {
        this.selectParam.createTime = this.selectParam.date[0]
        this.selectParam.endTime = this.selectParam.date[1]
        delete this.selectParam.date
      }
      this.$api.achievements.export(this.selectParam, '流程绩效.xls')
    }
  }
}
</script>

<style>
</style>
